<div class="" style="max-width: 800px; width: 100%">
  <div class="display-flex-space-between">
    <div class="big">
      {{
        'PARTECIPANT_LTI.TARGET_BONUS.TARGET_BONUS_ACCRUAL'
          | translate
          | uppercase
      }}
    </div>
    <div class="big">
      {{
        'PARTECIPANT_LTI.TARGET_BONUS.TARGET_BONUS_PAYMENT'
          | translate
          | uppercase
      }}
    </div>
  </div>
  <div class="spacer"></div>
  <div class="box sankey" id="sankey">
    <!-- <svg width="800" height="500"></svg> -->
    <ava-sankey [width]="800" [height]="400" [data]="data"></ava-sankey>
  </div>

  <div class="">
    <div class="spacer"></div>
    <div class="display-flex-space-between">
      <div class="big">
        {{
          'PARTECIPANT_LTI.TARGET_BONUS.TOTAL_TARGET_BONUS'
            | translate
            | uppercase
        }}
      </div>
      <div class="big bold">{{ getTotalTargetBonus() }}</div>
    </div>
    <div class="spacer"></div>
  </div>
</div>
